<template>
  <footer>
    <router-link to="/" class="logo"
      ><img src="@assets/img/mobile/footer_logo.svg" alt="푸터로고"
    /></router-link>
    <div class="footer-info">
      <p>
        (주)블루원 대표자명 : 김봉호 사업자등록번호 : 505-81-81749
        통신판매업신고 : 제 2014-경북경주-0170호<br />
        경기도 용인시 처인구 원삼면 보개원삼로1534번길 40
      </p>
      <span>copyright (c) 2016 blueone. all rights reserved.</span>
      <div class="social-icon">
        <p class="number">1899-1888</p>
        <a href="http://pf.kakao.com/_xfxdxmbj" target="_blank" class="kakao"
          ><img src="@assets/img/main/footer_kakao.svg" alt="카카오톡"
        /></a>
        <a href="https://naver.me/5y4qUYF3" target="_blank" class="naver"
          ><img src="@assets/img/main/footer_naver.svg" alt="네이버플레이스"
        /></a>
        <a
          href="https://www.instagram.com/blueone_yongin_c.c"
          target="_blank"
          class="instagram"
          ><img src="@assets/img/main/footer_instagram.svg" alt="인스타그램"
        /></a>
      </div>
    </div>

    <!--패밀리 사이트맵-->
    <div class="family-map">
      <div
        class="list-title"
        :class="{ open: familyList.list }"
        @click="familyList.list = !familyList.list"
      >
        <p>FAMILY SITE</p>
        <span class="icon" :class="{ active: familyList.list }"></span>
      </div>

      <ul class="list-content">
        <li>
          <a href="https://ty-holdings.co.kr/" target="_blank">TY 홀딩스</a>
        </li>
        <li>
          <a href="https://www.taeyoung.com/" target="_blank">태영건설</a>
        </li>
        <li><a href="https://www.sbs.co.kr/" target="_blank">SBS</a></li>
        <li>
          <a href="https://www.speedium.co.kr/" target="_blank">인제스피디움</a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { reactive } from 'vue';

const familyList = reactive({
  list: false,
});
</script>

<style scoped lang="scss">
footer {
  background: #414141;
  color: #9b9b9b;
  width: 100%;
  height: 265px;
  padding: 25px 16px;
  position: relative;
  bottom: 0;
  left: 0;
  .logo {
    display: inline-block;
    margin-bottom: 10px;
  }
}

.footer-info {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-size: 0.813rem;
  line-height: 18px;
  span {
    display: block;
    margin-top: 10px;
    font-size: 0.75rem;
    text-transform: uppercase;
  }
}

.social-icon {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  .number {
    font-size: 1.25rem;
    margin-right: 10px;
  }
  img {
    width: 21px;
    height: 21px;
  }
}

.family-map {
  width: 134px;
  margin: 20px auto 0 auto;
  border: 1px solid #9b9b9b;
  position: relative;
  .list-title {
    font-size: 0.875rem;
    color: #9b9b9b;
    text-align: center;
    display: block;
    padding: 5px 0;
    cursor: pointer;
  }
  .list-content {
    display: none;
    position: absolute;
    top: -123px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    width: calc(100% + 1px);
    li {
      text-align: left;
      font-size: 0.813rem;
      border-bottom: 1px solid #626262;
      color: #898989;
      a {
        display: block;
        padding: 5px 10px;
      }
    }
  }
  .list-title.open ~ .list-content {
    display: block;
  }
  .icon {
    position: absolute;
    right: 3px;
    top: 53%;
    transform: translateY(-50%);
    display: block;
    width: 25px;
    height: 25px;
    background: url('@assets/img/contents/icon_footer-plus.svg') no-repeat
      center center;
  }
  .icon.active {
    background: url('@assets/img/contents/icon_footer-minus.svg') no-repeat
      center center;
  }
}
</style>
